import { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Card,
  CardContent,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  CircularProgress,
  Tabs,
  Tab,
  Button,
} from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { getADcdnStats } from 'src/redux/actions/CDN';
import Layout from 'src/components/layout/Layout';
import { useDispatch } from 'react-redux';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Link } from 'react-router-dom';

export default function RequestsStats() {
  const [selectedYear, setSelectedYear] = useState(2024);
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [tab, setTab] = useState('overview');

  const dispatch = useDispatch();

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const years = [];

  const {
    totalRequestsPerMonth,
    requestsPerPlanPerMonth,
    filesPerPlanPerMonth,
    usersPerPlan,
    caps,
    totalMediaFiles,
    filterYear,
    filterMonth,
    isLoading,
    usersRanking,
  } = useSelector((state) => state.Cdn);

  const statsCards = [
    {
      id: 1,
      title: 'Total Requests',
      value: totalRequestsPerMonth,
      trend: 'up',
      change: '+1%',
    },
    {
      id: 2,
      title: 'Files Processed',
      value: totalMediaFiles,
      trend: 'up',
      change: '+10%',
    },
  ];

  const tableData = [
    {
      category: 'Cap',
      free: caps[0]?._doc?.value,
      basic: caps[1]?._doc?.value,
      premium: caps[2]?._doc?.value,
    },
    {
      category: 'Users',
      free: usersPerPlan[0]?.count,
      basic: usersPerPlan[1]?.count,
      premium: usersPerPlan[2]?.count,
    },
    {
      category: 'Files',
      free: filesPerPlanPerMonth[0]?.count,
      basic: filesPerPlanPerMonth[1]?.count,
      premium: filesPerPlanPerMonth[2]?.count,
    },
    {
      category: 'Total',
      free: requestsPerPlanPerMonth[0]?.requestsSum,
      basic: requestsPerPlanPerMonth[1]?.requestsSum,
      premium: requestsPerPlanPerMonth[2]?.requestsSum,
    },
  ];

  useEffect(() => {
    setSelectedYear(filterYear);
    setSelectedMonth(filterMonth);
  }, [filterYear, filterMonth]);

//   useEffect(() => {
    for (let x=1; x <= new Date().getFullYear() - 2024; x++) {
        years.push(2024+x)
    }
//   }, [])

  return (
    <Layout>
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Box sx={{ minHeight: '100vh' }}>
          <Container maxWidth='lg'>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Link to={'/report'}>
                <Button startIcon={<KeyboardBackspaceIcon />}>
                  Back to reports
                </Button>
              </Link>
              <Typography
                variant='subtitle1'
                sx={{ color: 'white', mb: 4, textAlign: 'left' }}
              >
                {months[selectedMonth - 1]} {selectedYear} Report
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  gap: 2,
                  mb: 4,
                }}
              >
                <CircularProgress
                  size={25}
                  sx={{ opacity: isLoading ? 1 : 0 }}
                />
                <FormControl sx={{ minWidth: 150 }}>
                  <InputLabel sx={{ color: 'white' }}>Month</InputLabel>
                  <Select
                    // value={selectedMonth}
                    disabled={isLoading}
                    onChange={(e) => {
                      dispatch(getADcdnStats(filterYear, e.target.value));
                      // setSelectedMonth(e.target.value)
                    }}
                    label='Month'
                    sx={{
                      color: 'white',
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white',
                      },
                      '.MuiSvgIcon-root': { color: 'white' },
                    }}
                  >
                    {months.map((month, index) => (
                      <MenuItem
                        key={month}
                        value={index + 1}
                        selected={selectedMonth == index + 1 ? true : false}
                      >
                        {month}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl sx={{ minWidth: 120 }}>
                  <InputLabel sx={{ color: 'white' }}>Year</InputLabel>
                  <Select
                  disabled={isLoading}
                    // value={selectedYear}
                    onChange={(e) => {
                      dispatch(getADcdnStats(e.target.value, filterMonth));
                      // setSelectedYear(e.target.value)
                      // console.log(e.target.value)
                    }}
                    label='Year'
                    sx={{
                      color: 'white',
                      '.MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white',
                      },
                      '.MuiSvgIcon-root': { color: 'white' },
                    }}
                  >
                    {years.map((year) => (
                      <MenuItem
                        key={year}
                        value={year}
                        selected={selectedYear == year ? true : false}
                      >
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3, mt: 3 }}>
              <Tabs
                value={tab}
                onChange={(e, newValue) => {
                  setTab(newValue);
                }}
                aria-label='Reports tabs'
              >
                <Tab label='Overview' value={'overview'} />
                <Tab label='Users ranking' value={'ranking'} />
                {/* <Tab label="Item Three" value={3} /> */}
              </Tabs>
            </Box>
            {tab == 'overview' && (
              <>
                {/* Period Heading */}

                {/* Stats Cards */}
                <Grid container spacing={3} sx={{ mb: 6 }}>
                  {statsCards.map((stat) => (
                    <Grid item xs={12} md={4} key={stat.id}>
                      <Card sx={{ bgcolor: '#34495e', height: '100%' }}>
                        <CardContent>
                          <Typography
                            variant='h6'
                            sx={{ color: '#95a5a6', mb: 2 }}
                          >
                            {stat.title}
                          </Typography>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Typography
                              variant='h3'
                              sx={{ color: 'white', fontWeight: 'bold' }}
                            >
                              {stat.value}
                            </Typography>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                              }}
                            >
                              {stat.trend === 'up' ? (
                                <TrendingUp
                                  sx={{ color: '#2ecc71', fontSize: 40 }}
                                />
                              ) : (
                                <TrendingDown
                                  sx={{ color: '#e74c3c', fontSize: 40 }}
                                />
                              )}
                              <Typography
                                variant='h6'
                                sx={{
                                  color:
                                    stat.trend === 'up' ? '#2ecc71' : '#e74c3c',
                                  fontWeight: 'bold',
                                }}
                              >
                                {stat.change}
                              </Typography>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>

                {/* Data Table */}
                <TableContainer component={Paper} sx={{ bgcolor: '#34495e' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ color: 'white', borderColor: '#4a5f7f' }}
                        ></TableCell>
                        <TableCell
                          align='center'
                          sx={{
                            color: 'white',
                            fontSize: '1.25rem',
                            fontWeight: 'bold',
                            borderColor: '#4a5f7f',
                          }}
                        >
                          Free
                        </TableCell>
                        <TableCell
                          align='center'
                          sx={{
                            color: 'white',
                            fontSize: '1.25rem',
                            fontWeight: 'bold',
                            borderColor: '#4a5f7f',
                          }}
                        >
                          Basic
                        </TableCell>
                        <TableCell
                          align='center'
                          sx={{
                            color: 'white',
                            fontSize: '1.25rem',
                            fontWeight: 'bold',
                            borderColor: '#4a5f7f',
                          }}
                        >
                          Premium
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableData.map((row) => (
                        <TableRow key={row.category}>
                          <TableCell
                            sx={{
                              color: 'white',
                              borderColor: '#4a5f7f',
                              fontSize: '1rem',
                            }}
                          >
                            {row.category}
                          </TableCell>
                          <TableCell
                            align='center'
                            sx={{
                              color: 'white',
                              borderColor: '#4a5f7f',
                              fontSize: '1rem',
                            }}
                          >
                            {row.free ? row.free : 0}
                          </TableCell>
                          <TableCell
                            align='center'
                            sx={{
                              color: 'white',
                              borderColor: '#4a5f7f',
                              fontSize: '1rem',
                            }}
                          >
                            {row.basic ? row.basic : 0}
                          </TableCell>
                          <TableCell
                            align='center'
                            sx={{
                              color: 'white',
                              borderColor: '#4a5f7f',
                              fontSize: '1rem',
                            }}
                          >
                            {row.premium ? row.premium : 0}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
            {tab == 'ranking' && (
              <>
                <TableContainer component={Paper} sx={{ bgcolor: '#34495e' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ color: 'white', borderColor: '#4a5f7f' }}
                        ></TableCell>
                        <TableCell
                          align='center'
                          sx={{
                            color: 'white',
                            fontSize: '1.25rem',
                            fontWeight: 'bold',
                            borderColor: '#4a5f7f',
                          }}
                        >
                          User
                        </TableCell>
                        <TableCell
                          align='center'
                          sx={{
                            color: 'white',
                            fontSize: '1.25rem',
                            fontWeight: 'bold',
                            borderColor: '#4a5f7f',
                          }}
                        >
                          Month requests
                        </TableCell>
                        <TableCell
                          align='center'
                          sx={{
                            color: 'white',
                            fontSize: '1.25rem',
                            fontWeight: 'bold',
                            borderColor: '#4a5f7f',
                          }}
                        >
                          Total requests
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {usersRanking?.length ? (
                        usersRanking.map((row, index) => (
                          <TableRow
                            key={row._id}
                            sx={{
                              '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                              },
                            }}
                          >
                            <TableCell
                              sx={{
                                color: 'white',
                                borderColor: '#4a5f7f',
                                fontSize: '1rem',
                              }}
                            >
                              <i>#{index + 1}</i>
                            </TableCell>
                            <TableCell
                              align='center'
                              sx={{
                                color: 'white',
                                borderColor: '#4a5f7f',
                                fontSize: '1rem',
                              }}
                            >
                              <Link to={`/user-details/${row?._id?.uid[0]}`}>
                                <b>{row?._id?.uem[0]}</b>
                                <br />
                                {row?._id?.ufm[0]}
                              </Link>
                            </TableCell>
                            <TableCell
                              align='center'
                              sx={{
                                color: 'white',
                                borderColor: '#4a5f7f',
                                fontSize: '1rem',
                              }}
                            >
                              {row?.monthSum}
                            </TableCell>
                            <TableCell
                              align='center'
                              sx={{
                                color: 'white',
                                borderColor: '#4a5f7f',
                                fontSize: '1rem',
                              }}
                            >
                              {row?.totalReq}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow key={0}>
                          <TableCell
                            sx={{
                              color: 'white',
                              borderColor: '#4a5f7f',
                              fontSize: '1rem',
                            }}
                            rowSpan={4}
                            align='center'
                          >
                            No user ranking stats
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
            {/* Month and Year Selects */}
          </Container>
        </Box>
      </Box>
    </Layout>
  );
}
